import { LoadingSpinnerPanel } from '@frontend/web-react/components/Primitives/Loading/LoadingSpinnerPanel';
import { AUTHENTICATED_HOME_ROUTE, createFileRoute, redirect } from '@frontend/web/utils/router';
import { lazy, Suspense } from 'react';
import { validateSignUpSearch } from './-publicSearch';

const LazySignUp = lazy(() => import('./-sign-up').then((module) => ({ default: module.SignUp })));

const SignUpRouteComponent = () => (
  <Suspense fallback={<LoadingSpinnerPanel fullScreen />}>
    <LazySignUp />
  </Suspense>
);

export const Route = createFileRoute('/sign-up')({
  beforeLoad: async ({ context }) => {
    if (context.authentication?.isAuthenticated) {
      throw redirect({ to: AUTHENTICATED_HOME_ROUTE });
    }
  },
  component: SignUpRouteComponent,
  validateSearch: validateSignUpSearch,
});
